import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Allocations_ModuleContextService } from './Allocations.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Allocations_order_class_types_dd_ComponentContextService {
  private readonly moduleContext: Allocations_ModuleContextService;

  constructor(moduleContext: Allocations_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'order_class_types_dd',
      type: ComponentType.selector
    }
  }
}